import { createUseStyles } from "react-jss";

const useStyles = createUseStyles(theme => ({
  settingsItem: {
    marginTop: 10,
    marginBottom: 5,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    "& input": {
      marginLeft: 30,
      height: 30,
      flexShrink: 0,
      width: "50%",
      maxWidth: 300,
      outline: "none",
      "border-radius": 4,
      padding: "3px 9px",
      fontSize: 15,
      border: "1px solid transparent",
      background: theme.colorBackground,
      color: "white",
      fontFamily: "DaytonaPro-Light",
      "&:focus": {
        border: `1px solid ${theme.colorPrimary} !important`,
      },
    },
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  image: {
    width: 30,
    height: 30,
    marginRight: 8,
  },
}));

const getHotspotIcon = name => `${window.location.origin}/assets/hotspots/${name}.png`;

const getUiAssetIcon = name => `${window.location.origin}/assets/hotspots/${name}.png`;

const TYPES = {
  crossfade: {
    icon: getHotspotIcon("crossfade"),
    label: "View crossfade",
  },
  autoplayFlows: {
    icon: getUiAssetIcon("walkthrough"),
    label: "Autoplay",
  },
};

export const TooltipsEditor = (props) => {
  const { value, onChange } = props;
  const classes = useStyles();

  const onChangeItem = (key, ev) => {
    const obj = {...(value || {})};
    obj[key] = ev.target.value;
    onChange({ target: { value: obj }})
  }

  return (
    <div>
      {Object.keys(TYPES).map((key, idx) => {
        const item = TYPES[key];
        return (
          <div className={classes.settingsItem} key={`tooltip_${idx}`}>
            <div className={classes.row}>
              <img src={item.icon} alt={`tooltip_${key}`} className={classes.image} />
              <label>{item.label}:</label>
            </div>
            <input
              value={value?.[key]}
              onChange={ev =>
                onChangeItem(key, ev)
              }
            />
          </div>
        )
      })}
    </div>
  )
}
